"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
const logger_1 = require("./logger");
const negotiator_1 = require("./negotiator");
const enums_1 = require("./enums");
const baseconnection_1 = require("./baseconnection");
/**
 * Wraps the streaming interface between two Peers.
 */
class MediaConnection extends baseconnection_1.BaseConnection {
    constructor(peerId, provider, options) {
        super(peerId, provider, options);
        this._localStream = this.options._stream;
        this.connectionId =
            this.options.connectionId ||
                MediaConnection.ID_PREFIX + util_1.util.randomToken();
        this._negotiator = new negotiator_1.Negotiator(this);
        if (this._localStream) {
            this._negotiator.startConnection({
                _stream: this._localStream,
                originator: true
            });
        }
    }
    get type() {
        return enums_1.ConnectionType.Media;
    }
    get localStream() { return this._localStream; }
    get remoteStream() { return this._remoteStream; }
    addStream(remoteStream) {
        logger_1.default.log("Receiving stream", remoteStream);
        this._remoteStream = remoteStream;
        super.emit(enums_1.ConnectionEventType.Stream, remoteStream); // Should we call this `open`?
    }
    handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        switch (message.type) {
            case enums_1.ServerMessageType.Answer:
                // Forward to negotiator
                this._negotiator.handleSDP(type, payload.sdp);
                this._open = true;
                break;
            case enums_1.ServerMessageType.Candidate:
                this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                logger_1.default.warn(`Unrecognized message type:${type} from peer:${this.peer}`);
                break;
        }
    }
    answer(stream, options = {}) {
        if (this._localStream) {
            logger_1.default.warn("Local stream already exists on this MediaConnection. Are you answering a call twice?");
            return;
        }
        this._localStream = stream;
        if (options && options.sdpTransform) {
            this.options.sdpTransform = options.sdpTransform;
        }
        this._negotiator.startConnection(Object.assign(Object.assign({}, this.options._payload), { _stream: stream }));
        // Retrieve lost messages stored because PeerConnection not set up.
        const messages = this.provider._getMessages(this.connectionId);
        for (let message of messages) {
            this.handleMessage(message);
        }
        this._open = true;
    }
    /**
     * Exposed functionality for users.
     */
    /** Allows user to close connection. */
    close() {
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        this._localStream = null;
        this._remoteStream = null;
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.options && this.options._stream) {
            this.options._stream = null;
        }
        if (!this.open) {
            return;
        }
        this._open = false;
        super.emit(enums_1.ConnectionEventType.Close);
    }
}
exports.MediaConnection = MediaConnection;
MediaConnection.ID_PREFIX = "mc_";
